import React from 'react';
import { Stack, Typography } from '@mui/material';
import { useTranslation } from 'react-i18next';
import { Outlet } from 'react-router-dom';

import { DashboardRoutes } from '@utils/routes.utils';

import RoutesTabsComponent from '@components/tabs/RoutesTabs.component';

const DashboardScreen = () => {
  const {t} = useTranslation();

  return (
    <Stack flex={1} width="100%" pt="34px" px="24px" spacing={2} overflow="hidden">
      <Typography fontSize="30px" fontWeight="700">
        {t('dashboard.title')}
      </Typography>
      <Stack flex={1} overflow="hidden">
        <RoutesTabsComponent routes={DashboardRoutes.routes()}/>
        <Outlet/>
      </Stack>
    </Stack>
  );
};

export default DashboardScreen;
